import { AdvancedFilterDataSchema } from "@redotech/redo-model/views/views";
import * as z from "zod/v4";

export const getForecastingProductsCount = {
  name: "getForecastingProductsCount" as const,
  input: z.object({
    search: z.string().optional(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).optional(),
  }),
  output: z.object({
    totalCount: z.number().int(),
    hasMultipleMerchants: z.boolean(),
  }),
};
